import { useState, useEffect } from "react";

/**
 * Mount-only data-fetch hook for Dispatch tab sub-views.
 * Pass a stable fetchFn (module-level or useCallback-wrapped) — called once on mount.
 */
export function useDigestQuery<T>(fetchFn: () => Promise<T>): { data: T | null; loading: boolean } {
  const [data, setData] = useState<T | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    fetchFn()
      .then((res) => { if (active) setData(res); })
      .catch(() => { if (active) setData(null); })
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
    // fetchFn is intentionally excluded — mount-only fetch; callers pass stable references
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { data, loading };
}
